import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState, useRef, useMemo } from "react";
import equals from "fast-deep-equal";

/**
 * A state that resets to its initial value when that value changes. Useful to
 * allow temporary modification of input properties.
 *
 * @param initial The value to track and reset to.
 * @param strict When true, compares by reference (`===`) instead of a deep equality check.
 */
export default function useInputState(initial) {
  var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _useState = useState(initial),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var initialRef = useRef(initial);
  useEffect(function () {
    if (isEqual(initial, initialRef.current, strict)) return;
    initialRef.current = initial;
    setState(initial);
  }, [initial, strict]);
  var isInitial = useMemo(function () {
    return isEqual(state, initial, strict);
  }, [state, initial, strict]);
  return [state, setState, isInitial];
}
function isEqual(a, b, strict) {
  return strict ? a === b : equals(a, b);
}
//# sourceMappingURL=useInputState.js.map